import React, { useState, useEffect, Fragment } from "react";
import { connect } from "react-redux";
import { Url } from "finhelper";
import { Button, Input, InputContainer } from "finform";

import { login, handleCloseModal } from "#app/store/actions/auth";
import { initialForbbiddenFormState } from "#app/api/login";

import { CenteredWrapper, Container, Row, TopRow } from "#app/pages/styles";
import { ButtonContainer, Form as StyledForm } from "#app/pages/Auth/styles";

import { Title1 } from "#app/components/texts/Typography";

interface ForbiddenProps {
    auth: boolean;
    data: any;
    login: (payload: any) => void;
    handleCloseModal: () => void;
}

const FormOnForbidden: React.FC<ForbiddenProps> = ({ auth, login, handleCloseModal }) => {
    const [form, setForm] = useState(initialForbbiddenFormState);
    const [formErrors, setFormErrors] = useState<Record<string, string[]>>({});

    const getError = (fieldName: string): string | null => {
        return formErrors[fieldName]?.[0] || null;
    };

    const handleInputChange = (field: string, value: string) => {
        setForm((prev) => ({ ...prev, [field]: value }));
        setFormErrors((prev) => ({ ...prev, [field]: [] }));
    };

    const submitForm = () => {
        login({
            form,
            success: (response: any, status: number, xhr: any) => {
                const header = xhr.getResponseHeader("Authorization");

                if (header) {
                    localStorage.setItem("api_token", header);
                    handleCloseModal();
                } else {
                    console.error("Ошибка авторизации");
                }
            },
            error: (xhr: any, responseData: any) => {
                if (responseData?.meta?.errors) {
                    setFormErrors((prevErrors) => ({
                        ...prevErrors,
                        ...responseData.meta.errors,
                    }));
                }
            },
            obj: {
                state: form,
                setState: (stateUpdater: any) => setForm((prev) => stateUpdater(prev)),
            },
        });
    };

    useEffect(() => {
        // window.scrollTo(0, 0);
    }, []);

    const url = Url.getCurrentUrl();

    return (
        <Container
            style={{ margin: url.indexOf("/cabinet") !== -1 ? "0 auto" : "20px auto 0 auto" }}
        >
            <CenteredWrapper>
                <StyledForm
                    action="#"
                    onSubmit={(e) => {
                        e.preventDefault();
                        submitForm();
                    }}
                >
                    <TopRow>
                        <Title1 style={{ width: "100%", textAlign: "center" }} white>
                            У вас недостаточно прав, авторизуйтесь
                        </Title1>
                    </TopRow>
                    {!auth && (
                        <Fragment>
                            <Row>
                                <InputContainer error={getError("email")}>
                                    <Input
                                        id="login-email"
                                        autoComplete="on"
                                        name="email"
                                        value={form.email}
                                        onChange={(value) =>
                                            handleInputChange(
                                                "email",
                                                typeof value === "function"
                                                    ? value(form.email)
                                                    : value
                                            )
                                        }
                                        placeholder="Email"
                                    />
                                </InputContainer>
                            </Row>
                            <Row>
                                <InputContainer error={getError("password")}>
                                    <Input
                                        id="login-password"
                                        type="password"
                                        name="password"
                                        value={form.password}
                                        onChange={(value) =>
                                            handleInputChange(
                                                "password",
                                                typeof value === "function"
                                                    ? value(form.password)
                                                    : value
                                            )
                                        }
                                        placeholder="Пароль"
                                    />
                                </InputContainer>
                            </Row>
                            <ButtonContainer style={{ margin: "0 auto", padding: 0 }}>
                                <Button
                                    id="login-submit"
                                    type="main"
                                    style={{ width: "300px", height: "56px" }}
                                >
                                    Войти
                                </Button>
                            </ButtonContainer>
                        </Fragment>
                    )}
                </StyledForm>
            </CenteredWrapper>
        </Container>
    );
};

const enhance = connect(
    (state: any) => ({
        auth: state.auth.auth,
        data: state.auth.data,
    }),
    { login, handleCloseModal }
);

export default enhance(FormOnForbidden);
